import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Message } from 'mage-i18n';
import { Typography } from '@klarna/bubble-ui';

import { STAKEHOLDER_ROLES_V2 } from '@/containers/withStakeholderLogic';
import { getStakeholdersByRoles } from '@/selectors/merchant';

import Stakeholders from './SummaryStakeholdersByType';
import { BUSINESS_OWNER } from './constants';

const SummaryBusinessOwners = ({ noElementsTKey, businessOwners = [] }) =>
  businessOwners && businessOwners.length ? (
    <Stakeholders
      type="businessOwners"
      stakeholders={businessOwners}
      showPep={false}
      role={BUSINESS_OWNER}
    />
  ) : (
    <Typography
      textToken="text-style/text/super-paragraphs/tall/regular"
      colorToken="colors/text/neutral"
    >
      <Message path={noElementsTKey} />
    </Typography>
  );

SummaryBusinessOwners.propTypes = {
  noElementsTKey: PropTypes.string.isRequired,
  businessOwners: PropTypes.array,
};

export default connect(state => ({
  businessOwners: getStakeholdersByRoles([
    STAKEHOLDER_ROLES_V2.OWNER,
    STAKEHOLDER_ROLES_V2.SOLE_TRADER,
    STAKEHOLDER_ROLES_V2.PARTNER,
  ])(state),
}))(SummaryBusinessOwners);
